import React, { useState, useRef, useEffect } from "react";
import api, { formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Bot, Send, Sparkles } from "lucide-react";

const SUGGESTIONS = [
  "In che ordine conviene fare le mie consegne attive?",
  "Quante consegne ho fatto oggi?",
  "Come funziona l'incasso in contanti?",
  "Sono disponibile per ricevere ordini?",
];

export default function RiderAI() {
  const [msgs, setMsgs] = useState([{ role: "ai", text: "Ciao! Sono il tuo assistente rider. Ti aiuto con priorità delle consegne, guadagni di oggi e domande sull'app. Chiedimi pure." }]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs, loading]);

  const send = async (text) => {
    const q = (text ?? input).trim();
    if (!q || loading) return;
    setInput("");
    setMsgs((m) => [...m, { role: "user", text: q }]);
    setLoading(true);
    try {
      const { data } = await api.post("/rider/ai/chat", { message: q });
      setMsgs((m) => [...m, { role: "ai", text: data.answer }]);
    } catch (e) {
      setMsgs((m) => [...m, { role: "ai", text: formatApiError(e.response?.data?.detail) || "Assistente non disponibile ora." }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4" data-testid="rider-ai-panel">
      <div className="flex items-center gap-2">
        <div className="h-10 w-10 rounded-xl bg-[#00E676]/15 grid place-items-center"><Bot className="h-5 w-5 text-[#00E676]" /></div>
        <div><h3 className="font-semibold flex items-center gap-2">Assistente Rider AI <Sparkles className="h-4 w-4 text-[#FFD700]" /></h3>
          <p className="text-xs text-zinc-500">Risposte basate sui tuoi dati reali. Non fornisce indicazioni stradali.</p></div>
      </div>

      <div className="rounded-2xl bg-[#131316] border border-white/10 p-4 min-h-[340px] max-h-[52vh] overflow-y-auto space-y-3" data-testid="rider-ai-messages">
        {msgs.map((m, i) => (
          <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[85%] rounded-2xl px-3.5 py-2.5 text-sm whitespace-pre-wrap ${m.role === "user" ? "bg-[#00E676] text-black" : "bg-white/5 text-zinc-100 border border-white/10"}`}>{m.text}</div>
          </div>
        ))}
        {loading && <div className="flex justify-start"><div className="bg-white/5 border border-white/10 rounded-2xl px-3.5 py-2.5 text-sm text-zinc-400">Sto pensando…</div></div>}
        <div ref={endRef} />
      </div>

      <div className="flex flex-wrap gap-2">
        {SUGGESTIONS.map((s) => (
          <button key={s} onClick={() => send(s)} disabled={loading} data-testid="rider-ai-suggestion" className="text-xs px-3 py-1.5 rounded-full border border-white/10 text-zinc-300 hover:border-[#00E676]/40 hover:text-[#00E676] transition-colors disabled:opacity-50">{s}</button>
        ))}
      </div>

      <div className="flex gap-2">
        <input value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Scrivi una domanda…" data-testid="rider-ai-input" className="flex-1 bg-[#0A0A0C] border border-white/10 rounded-xl h-11 px-4 text-sm focus:border-[#00E676]/50 outline-none" />
        <Button onClick={() => send()} disabled={loading || !input.trim()} data-testid="rider-ai-send" className="bg-[#00E676] text-black h-11 px-4"><Send className="h-4 w-4" /></Button>
      </div>
    </div>
  );
}
